import axios from '../../../../utils/AxiosUtils';
import i18n from '../../../../i18next';

import {
    LOADING,
    LOAD_CURBSIDE_SETTINGS_SUCCESS,
    UPDATE_CURBSIDE_SETTINGS_SUCCESS, RESET_CURBSIDE_SETTINGS
} from '../../../types';
import MessageUtils from "../../../../utils/MessageUtils";
import { doLoadOpeningHours } from '../../../index';

export const loadCurbsideSettings = (restaurantId) => {
    return (dispatch, getState) => {
        dispatch({ type: LOADING, payload: true });

        const url = `/settings/${restaurantId}/curbside`;

        axios().get(url)
            .then(response => loadCurbsideSettingsSuccess(dispatch, response, getState, restaurantId))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:deliveryActions.loadSettingsFailure')));
    }
}

const loadCurbsideSettingsSuccess = (dispatch, response, getState, restaurantId) => {
    if (response.status === 204) {
        const saveDataToScreen = 'curbside';
        doLoadOpeningHours(restaurantId, dispatch, getState, saveDataToScreen);
    }

    dispatch({ type: LOADING, payload: false });

    if (response.status !== 204) {
        dispatch({ type: LOAD_CURBSIDE_SETTINGS_SUCCESS, payload: response.data });
    }
}

export const updateCurbsideSettings = (restaurantId, state, callback) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });

        const url = `/settings/${restaurantId}/curbside`;

        const curbsideSettings = {
            id: state.id,
            preparationTimes: state.preparationTimes,
            supportedTenderTypes: state.supportedTenderTypes,
            minimumOrderAmount:
                state.minimumOrderAmount === undefined || state.minimumOrderAmount === null || state.minimumOrderAmount === '' ?
                    1 : Number(state.minimumOrderAmount),
            maximumOrderAmount:
                state.maximumOrderAmount === undefined || state.maximumOrderAmount === null || state.maximumOrderAmount === '' ?
                    null : Number(state.maximumOrderAmount),
            timeSlots: state.timeSlots,
            nextDayOrdersOnly: state.nextDayOrdersOnly,
            nextDayOrdersNumber: state.nextDayOrdersNumber,
            serviceNote: state.serviceNote
        }

        axios().post(url, curbsideSettings)
            .then(response => updateCurbsideSettingsSuccess(dispatch, response, callback))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:posSettings.saveFailure')));
    }
}

const updateCurbsideSettingsSuccess = (dispatch, response, callback) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: UPDATE_CURBSIDE_SETTINGS_SUCCESS, payload: response.data });
    if (callback) {
        callback();
    }
    MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:posSettings.saveSuccess'));
}

export const resetCurbsideSettings = () => {
    return (dispatch) => {
        dispatch({ type: RESET_CURBSIDE_SETTINGS });
    }
};


// WEBPACK FOOTER //
// ./src/actions/restaurants/settings/service/CurbsideActions.js